<div class="page">
  <div class="wrapper">
    <div class="info-title flex-row">
      <h1>{{ site }} Inspection Center</h1>
      <!-- <div class="button button-secondary" routerLink="/suppliers" *ngIf="isAdmin">Go to Suppliers page...</div> -->
    </div>

    <div class="flex-row search-section">
      <input
        placeholder="Search Order ID.."
        type="text"
        class="input input-lg search-bar"
        [(ngModel)]="idFilter"
        [disabled]="!listLoaded"
        (input)="filterOrderList(this.sortOrderList)"
        />
      <span class="gutter"></span>
      <input
        placeholder="Search SMN..."
        type="text"
        class="input input-lg search-bar"
        [(ngModel)]="smnFilter"
        [disabled]="!listLoaded"
        (input)="filterOrderList(this.sortOrderList)"
        />
      <span class="gutter"></span>
      <input
        placeholder="Search Supplier Name"
        type="text"
        class="input input-lg search-bar"
        [(ngModel)]="supplierName"
        [disabled]="!listLoaded"
        (input)="filterOrderList(this.sortOrderList)"
        />
      <!--      <input  placeholder="Search PO Number..." type="text" class="input input-lg search-bar" [(ngModel)]="poFilter" (input)="filterOrderList()">-->
    </div>

    <div class="flex-row filter-section">
      <div class="filter-item">
        <span> Status: </span>
        <select
          [(ngModel)]="statusFilter"
          [disabled]="!listLoaded"
          (change)="filterOrderList(this.sortOrderList)"
          >
          <option [value]="'All'">All</option>
          <option [value]="'Pending'">Pending</option>
          <option [value]="'Uploaded To SAP'">Uploaded To SAP</option>
          <option [value]="'Resubmission Required'">
            Resubmission Required
          </option>
          <option [value]="'Received'">Received</option>
        </select>
      </div>

      <div class="filter-item">
        <span> Order Type: </span>
        <select
          [(ngModel)]="typeFilter"
          [disabled]="!listLoaded"
          (change)="filterOrderList(this.sortOrderList)"
          >
          <option [value]="'All'">All</option>
          <option [value]="'Standard'">Standard</option>
          <option [value]="'Non-Standard'">Non-Standard</option>
        </select>
      </div>
    </div>

    <div class="content-section">
      <div class="content-header">
        <ul class="flex-row">
          <li class="flex-2" (click)="sortOrderList('inspectorStatus')">
            Status
            @if (sortFilter === 'inspectorStatus') {
              <img
                alt=""
                src="./assets/sort-arrow.svg"
                [ngClass]="{ 'descending-order': !sortAscending }"
                />
            }
          </li>
          <li class="flex-2" (click)="sortOrderList('inspectorID')">
            Order ID
            @if (sortFilter === 'inspectorID') {
              <img
                alt=""
                src="./assets/sort-arrow.svg"
                [ngClass]="{ 'descending-order': !sortAscending }"
                />
            }
          </li>
          <li class="flex-2" (click)="sortOrderList('SMN')">
            SMN
            @if (sortFilter === 'SMN') {
              <img
                alt=""
                src="./assets/sort-arrow.svg"
                [ngClass]="{ 'descending-order': !sortAscending }"
                />
            }
          </li>
          <li class="flex-2" (click)="sortOrderList('revisionNumber')">
            SMN Revision
            @if (sortFilter === 'revisionNumber') {
              <img
                alt=""
                src="./assets/sort-arrow.svg"
                [ngClass]="{ 'descending-order': !sortAscending }"
                />
            }
          </li>
          <li class="flex-2" (click)="sortOrderList('supplierName')">
            Supplier Name
            @if (sortFilter === 'supplierName') {
              <img
                alt=""
                src="./assets/sort-arrow.svg"
                [ngClass]="{ 'descending-order': !sortAscending }"
                />
            }
          </li>
          <li class="flex-2" (click)="sortOrderList('submissionDate')">
            Submission Date
            @if (sortFilter === 'submissionDate') {
              <img
                alt=""
                src="./assets/sort-arrow.svg"
                [ngClass]="{ 'descending-order': !sortAscending }"
                />
            }
          </li>
          <li class="flex-2">Quantity</li>
          <li class="flex-2">Last Modified By</li>
        </ul>
      </div>

      @if (orderList.length > 0 && this.listLoaded) {
        <div>
          @for (
            order of orderList
            | paginate : { itemsPerPage: 10, currentPage: page }
            ; track
            order) {
            <div
              class="content-main"
              >
              <div class="content-item" (click)="selectOrder(order.inspectorID)">
                <ul class="item-main flex-row">
                  <li class="flex-2">{{ order.inspectorStatus }}</li>
                  <li class="flex-2">{{ order.inspectorID }}</li>
                  <li class="flex-2">{{ order.SMN }}</li>
                  <li class="flex-2">{{ order.revisionNumber }}</li>
                  <li class="flex-2">{{ order.supplierName }}</li>
                  <li class="flex-2">{{ order.submissionDate | date }}</li>
                  <li class="flex-2">{{ order.quantity }}</li>
                  <li class="flex-2">{{ order.modifiedBy }}</li>
                </ul>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="loading-container">
          @if (!this.listLoaded) {
            <div class="flex-row spinner">
              <mat-progress-spinner
                mode="indeterminate"
                diameter="150"
              ></mat-progress-spinner>
            </div>
            <div class="flex-row message">
              <h2>Loading Orders...</h2>
            </div>
          } @else {
            <div class="flex-row message">
              <h2>No orders according to given criteria are found</h2>
            </div>
          }
        </div>
      }


      @if (listLoaded && this.orderList.length > 0) {
        <pagination-controls
          (pageChange)="page = $event"
        ></pagination-controls>
      }
      @if (!listLoaded) {
        <div class="flex-row center">
          <div class="flex-col">
            <mat-progress-spinner
              mode="indeterminate"
              diameter="25"
            ></mat-progress-spinner>
          </div>
          <diV class="flex-col">
            <span>
              List is still being loaded, please do not refresh the page.
            </span>
          </diV>
        </div>
      }
    </div>
  </div>
</div>
